export default "__VITE_ASSET__DpOH7bU9__"